export default __webpack_public_path__ + "static/media/parceiros.3bbb6713.png";